import { cosmoAPI } from "@/core/Api/cosmoAxiosInstance";

export default {
  //#region Organization > Tag
  getOrganizationTagList(organizationId, params) {
    return cosmoAPI.get(
      `/organization/${organizationId}/tag/`,
      {
        params,
      }
    );
  },
  getOrganizationTagDetail(organizationId, tagId) {
    return cosmoAPI.get(
      `/organization/${organizationId}/tag/${tagId}/`
    );
  },
  createOrganizationTag(organizationId, tag) {
    return cosmoAPI.post(
      `/organization/${organizationId}/tag/`,
      tag,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  deleteOrganizationTag(organizationId, tagId) {
    return cosmoAPI.delete(
      `/organization/${organizationId}/tag/${tagId}/`
    );
  },
  updateOrganizationTag(organizationId, tag) {
    return cosmoAPI.patch(
      `/organization/${organizationId}/tag/`,
      tag,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};
